module.exports = __webpack_public_path__ + "static/Campus Groups-a11d6518abdd8ce63b7489b95e06c76c.jpg";